
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import FaceDirectionResultEffectFaceFront from '@/components/facetracker/FaceDirectionResultEffectFaceFront.vue';
import FaceDirectionResultEffectFaceUp1 from '@/components/facetracker/FaceDirectionResultEffectFaceUp1.vue';
import FaceDirectionResultEffectFaceUp2 from '@/components/facetracker/FaceDirectionResultEffectFaceUp2.vue';
import FaceDirectionResultEffectFaceUp3 from '@/components/facetracker/FaceDirectionResultEffectFaceUp3.vue';
import FaceDirectionResultEffectFaceUp4 from '@/components/facetracker/FaceDirectionResultEffectFaceUp4.vue';
import FaceDirectionResultEffectFaceDown1 from '@/components/facetracker/FaceDirectionResultEffectFaceDown1.vue';
import FaceDirectionResultEffectFaceDown2 from '@/components/facetracker/FaceDirectionResultEffectFaceDown2.vue';
import FaceDirectionResultEffectFaceDown3 from '@/components/facetracker/FaceDirectionResultEffectFaceDown3.vue';
import FaceDirectionResultEffectFaceDown4 from '@/components/facetracker/FaceDirectionResultEffectFaceDown4.vue';
import FaceDirectionResultEffectFaceLeft1 from '@/components/facetracker/FaceDirectionResultEffectFaceLeft1.vue';
import FaceDirectionResultEffectFaceLeft2 from '@/components/facetracker/FaceDirectionResultEffectFaceLeft2.vue';
import FaceDirectionResultEffectFaceLeft3 from '@/components/facetracker/FaceDirectionResultEffectFaceLeft3.vue';
import FaceDirectionResultEffectFaceLeft4 from '@/components/facetracker/FaceDirectionResultEffectFaceLeft4.vue';
import FaceDirectionResultEffectFaceRight1 from '@/components/facetracker/FaceDirectionResultEffectFaceRight1.vue';
import FaceDirectionResultEffectFaceRight2 from '@/components/facetracker/FaceDirectionResultEffectFaceRight2.vue';
import FaceDirectionResultEffectFaceRight3 from '@/components/facetracker/FaceDirectionResultEffectFaceRight3.vue';
import FaceDirectionResultEffectFaceRight4 from '@/components/facetracker/FaceDirectionResultEffectFaceRight4.vue';
import FaceDirectionResultEffectIconDirection from '@/components/facetracker/FaceDirectionResultEffectIconDirection.vue';
import FaceDirectionResultEffectIconSuccess from '@/components/facetracker/FaceDirectionResultEffectIconSuccess.vue';
import FaceDirectionResultEffectIconFailure from '@/components/facetracker/FaceDirectionResultEffectIconFailure.vue';

export type StatusResultEffect = 'none' | 'left' | 'right' | 'up' | 'down' | 'success' | 'failure';

@Component({
  components: {
    FaceDirectionResultEffectFaceFront,
    FaceDirectionResultEffectFaceUp1,
    FaceDirectionResultEffectFaceUp2,
    FaceDirectionResultEffectFaceUp3,
    FaceDirectionResultEffectFaceUp4,
    FaceDirectionResultEffectFaceDown1,
    FaceDirectionResultEffectFaceDown2,
    FaceDirectionResultEffectFaceDown3,
    FaceDirectionResultEffectFaceDown4,
    FaceDirectionResultEffectFaceLeft1,
    FaceDirectionResultEffectFaceLeft2,
    FaceDirectionResultEffectFaceLeft3,
    FaceDirectionResultEffectFaceLeft4,
    FaceDirectionResultEffectFaceRight1,
    FaceDirectionResultEffectFaceRight2,
    FaceDirectionResultEffectFaceRight3,
    FaceDirectionResultEffectFaceRight4,
    FaceDirectionResultEffectIconDirection,
    FaceDirectionResultEffectIconSuccess,
    FaceDirectionResultEffectIconFailure
  }
})
export default class Parts extends Vue {
  private rotation: number = 0;
  private actionCode: string = '0000';
  private actionStep: number = 0;

  @Prop({ type: String, required: true })
  public statusResultEffect!: StatusResultEffect;

  @Watch('statusResultEffect')
  handleStatusResultEffect(value: StatusResultEffect): void {
    if (value === 'up') {
      this.actionIncrement(-90);
    } else if (value === 'right') {
      this.actionIncrement(0);
    } else if (value === 'down') {
      this.actionIncrement(90);
    } else if (value === 'left') {
      this.actionIncrement(180);
    } else if (value === 'success') {
      this.actionDecrement();
    } else if (value === 'failure') {
      this.actionStop(1000);
    } else {
      this.actionStop(0);
    }
  }

  private get isDirection(): boolean {
    if (this.statusResultEffect === 'up') return true;
    if (this.statusResultEffect === 'right') return true;
    if (this.statusResultEffect === 'down') return true;
    if (this.statusResultEffect === 'left') return true;
    return false;
  }

  private async actionIncrement(rotation: number): Promise<void> {
    this.rotation = rotation;
    const actionCode: string = `0000${Math.floor(Math.random() * 9999 + 1)}`.substr(-4);
    this.actionCode = actionCode;
    this.actionStep = 1;
    await new Promise((resolve) => setTimeout(resolve, 600));
    if (this.actionCode !== actionCode) return;
    this.actionStep = 2;
    await new Promise((resolve) => setTimeout(resolve, 600));
    if (this.actionCode !== actionCode) return;
    this.actionStep = 3;
    await new Promise((resolve) => setTimeout(resolve, 600));
    if (this.actionCode !== actionCode) return;
    this.actionStep = 4;
  }

  private async actionDecrement(): Promise<void> {
    const actionCode: string = `0000${Math.floor(Math.random() * 9999 + 1)}`.substr(-4);
    this.actionCode = actionCode;
    this.actionStep = 3;
    await new Promise((resolve) => setTimeout(resolve, 200));
    if (this.actionCode !== actionCode) return;
    this.actionStep = 2;
    await new Promise((resolve) => setTimeout(resolve, 200));
    if (this.actionCode !== actionCode) return;
    this.actionStep = 1;
    await new Promise((resolve) => setTimeout(resolve, 200));
    if (this.actionCode !== actionCode) return;
    this.actionStep = 0;
  }

  private async actionStop(delay: number): Promise<void> {
    const actionCode: string = `0000${Math.floor(Math.random() * 9999 + 1)}`.substr(-4);
    this.actionCode = actionCode;
    await new Promise((resolve) => setTimeout(resolve, delay));
    if (this.actionCode !== actionCode) return;
    this.actionStep = 0;
  }
}
